import { TypographyProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SHADOWS } from '../../styles/sxStyling';
import { appZIndex } from '../../styles/zIndex';

const borderParams = (theme: Theme) => `1px solid ${theme.palette.divider}`;

export const formHeaderSx = {
  ...SHADOWS.secondary,
  backgroundColor: 'background.paper',
  borderBottom: borderParams,
  position: 'sticky',
  top: 0,
  zIndex: appZIndex.base,
};

export const formHeaderContainerSx = {
  px: { xs: 2, sm: 4 },
  py: 1.5,
};

export const formHeaderLayoutSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const formLogoContainerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const formLogoSx = {
  height: 30,
};

export const formHeaderTitleStackSx = {
  alignItems: 'center',
  textAlign: 'center',
};

export const formHeaderProps: TypographyProps = {
  variant: 'h4',
  fontWeight: 'bold',
};

export const headerSubtitleProps: TypographyProps = {
  fontWeight: 'bold',
  variant: 'body2',
  color: 'textSecondary',
};

export const attachmentAltProps: TypographyProps = {
  variant: 'body2',
  color: 'textSecondary',
};

export const dueDateStackSx = {
  alignItems: { xs: 'flex-end', lg: 'center' },
};

export const dueDatePillSx = {
  backgroundColor: (theme: Theme) => theme.palette.primary.light,
  color: (theme: Theme) => theme.palette.primary.main,
  fontWeight: 'bolder',
  px: 1,
  '& .MuiChip-icon': {
    fontSize: '16px',
    color: (theme: Theme) => theme.palette.primary.main,
  },
};

export const formMainContainerSx = {
  py: 3,
  px: { xs: 2, sm: 3 },
};

export const fieldRowSx = {
  py: 1,
};

export const buttonRowSx = {
  display: 'flex',
  gap: 2,
  justifyContent: 'flex-end',
};

export const sectionSx = {
  border: borderParams,
  borderRadius: 3,
  backgroundColor: (theme: Theme) => theme.palette.background.paper,
  p: 2.5,
};

export const attachmentRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  p: 1.5,
  border: borderParams,
  borderRadius: 2,
};

export const attachmentItemSx = {
  display: 'flex',
  gap: 1.5,
};

export const attachmentIconSx = {
  display: 'flex',
  alignItems: 'center',
  color: 'text.secondary',
};

export const attachmentLinkSx = {
  fontWeight: 'bold',
  overflowWrap: 'anywhere',
};

export const attachmentUploadActionsSx = {
  display: 'flex',
  justifyContent: 'flex-end',
};
